import {Header} from "../components/Header";
import React, {useEffect, useState} from "react";
import LiveDarshanModal from "../components/LiveDarshanModal";
import {useNavigate} from "react-router-dom";
import {t} from "i18next";
import {toast} from "react-toastify";
import {fetchReligiousPageBaseData} from "../service/baseDataApi";

export const Vyadeshwar = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [baseData, setBaseData] = useState({});

    const [isModalOpen, setModalOpen] = useState(false);
    const [liveStreamData, setLiveStreamData] = useState({
        title: "",
        videoId: "",
        streamingSoonMaskUrl: ""
    });

    const fetchBaseData = async () => {
        try {
            const response = await fetchReligiousPageBaseData("vyadeshwar-guhagar");
            console.log("Vyadeshwar Page Base Data: ", response);
            if (response.success) {
                setBaseData(response.data.data);
                setLiveStreamData({
                    title: t("RELIGIOUS_PAGE.VYADESHWAR.LIVE_DARSHAN.MODAL_TITLE"),
                    videoId: response.data.data.liveDarshanYouTubeId,
                    streamingSoonMaskUrl: response.data.data.liveDarshanStreamingSoonBannerUrl
                });
            } else {
                toast.dismiss()
                toast.error(response.error);
            }
        } catch (error) {
            console.log("Error fetching Vyadeshwar Page Base Data: ", error);
            toast.dismiss()
            toast.error(error.message);
        }
        setLoading(false);
    }

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    useEffect(() => {
        // Scroll to top when the page is rendered
        window.scrollTo(0, 0);
        fetchBaseData();
    }, []);

    if (loading) {
        return (
            <div className="w-full h-screen flex items-center justify-center">
                <Header/>

                <div className={"w-[100vw] h-[100vh] bg-[#F7F7F7] flex items-center justify-center"}>
                    <h1 className={"text-[5vw] font-custom-mono-bold"}>
                        Loading...
                    </h1>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="w-full flex flex-col items-center justify-center">
                <Header/>

                <img
                    src="/other_imgs/banner-dharmik-inside.jpg"
                    alt="Information Banner"
                    className="w-full h-[30vh] object-cover shadow-lg"
                />

                <div className="h-[70vh] flex flex-col">
                    <h1 className="text-center font-custom-bold text-3xl my-[4vh] text-red-800">
                        {t("RELIGIOUS_PAGE.VYADESHWAR.PAGE_TITLE")}
                    </h1>

                    <div
                        className="sm:flex sm:flex-row flex flex-col-reverse sm:h-[50vh]
                            justify-between p-[2vh] pt-0 gap-y-[2vh] gap-x-[2rem]"
                    >
                        {/* Left Section - Image */}
                        <div className="h-auto w-full flex gap-[2rem]">
                            {/*<div className="h-full aspect-square flex-1 flex items-center justify-center">*/}

                            {/*</div>*/}
                            <p className="leading-snug text-justify font-custom-medium text-[1.25rem]">
                                <img
                                    src="/assets/image-vyadeshwar.png"
                                    alt="Vyadeshwar Mandir Idol"
                                    className="sm:max-h-[25rem] aspect-square object-cover
                                    sm:mr-[2rem] float-left shadow-md rounded-lg"
                                />
                                {t("RELIGIOUS_PAGE.VYADESHWAR.DESCRIPTION")}
                            </p>
                        </div>

                        {/* Right Section - Buttons */}
                        <div
                            className="portrait:w-full landscape:w-1/3 h-auto flex flex-col items-center justify-between gap-y-[1rem]"
                        >
                            {/* Temple Time Table */}
                            <button
                                className="w-full min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"
                            >
                                <img
                                    alt={"Temple Time Table"}
                                    src="/other_imgs/icon-temple-timetable.png"
                                    className="h-[80%] aspect-square"
                                />
                                <p className={"font-bold text-[2.5vh] text-white"}>
                                    {t("RELIGIOUS_PAGE.VYADESHWAR.MANDIR_TIMETABLE.BUTTON_TITLE")}
                                </p>
                            </button>

                            {/* Aarti */}
                            <button
                                className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700
                                    px-6 py-2 rounded-xl shadow
                                    flex items-center justify-center gap-x-[2vh]
                                    w-full flex-1 min-h-[8vh] max-h-[8vh]"
                                onClick={() => {
                                    toast.dismiss();
                                    toast.info("Coming Soon!");
                                }}
                            >
                                <img
                                    alt={"Aarti"}
                                    src="/other_imgs/thumbnail-aarti.jpg"
                                    className="h-[80%] aspect-square rounded-lg"
                                />
                                <p className={"font-bold text-[2.5vh] text-white"}>
                                    {t("RELIGIOUS_PAGE.AARTI")}
                                </p>
                            </button>

                            {/* Live Darshan */}
                            <button
                                className="w-full flex-1 min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"
                                onClick={() => setModalOpen(true)}
                            >
                                <img
                                    alt={"Live Darshan"}
                                    src="/other_imgs/icon-live-recording-dot.png"
                                    className="h-[80%] aspect-square"
                                />
                                <p className={"font-bold text-[2.5vh] text-white"}>
                                    {t("RELIGIOUS_PAGE.VYADESHWAR.LIVE_DARSHAN.BUTTON_TITLE")}
                                </p>
                            </button>

                            {/* Mantropchar */}
                            <button
                                className="bg-gradient-to-tr from-orange-400 via-orange-500 to-orange-700
                                    px-6 py-2 rounded-xl shadow
                                    flex items-center justify-center gap-x-[2vh]
                                    w-full flex-1 min-h-[8vh] max-h-[8vh]"
                                onClick={() => {
                                    toast.dismiss();
                                    toast.info("Coming Soon!");
                                }}
                            >
                                <img
                                    alt={"Mantrochar"}
                                    src="/other_imgs/thumbnail-mantropchar.jpg"
                                    className="h-[80%] aspect-square rounded-lg"
                                />
                                <p className={"font-bold text-[2.5vh] text-white"}>
                                    {t("RELIGIOUS_PAGE.MANTROPCHAR")}
                                </p>
                            </button>

                            {/* Book Puja */}
                            <button
                                className="w-full min-h-[8vh] max-h-[8vh]
                                flex items-center justify-center gap-x-[2vh]
                                bg-red-600 hover:bg-red-700
                                px-6 py-2 rounded-xl shadow
                                text-white font-custom-bold text-[2.5vh]"
                            >
                                <p className={"font-bold text-[2.5vh] text-white"}>
                                    {t("RELIGIOUS_PAGE.VYADESHWAR.BOOK_PUJA.BUTTON_TITLE")}
                                </p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal */}
            <LiveDarshanModal
                isModalOpen={isModalOpen}
                closeModal={() => setModalOpen(false)}
                liveStreamData={liveStreamData}
            />
        </>
    );
};
